import { retry, tap, map } from "rxjs/operators";
import Report from "@/models/report";
import { ActionContext, Module } from "vuex";
import { StoreData } from "@/store";
import { ReportService } from "@/services/report.service";

export interface ReportData {
  reports: Report[];
}

export default {
  namespaced: true,
  state: (): ReportData => ({
    reports: [],
  }),
  actions: {
    resetReports: (context: ActionContext<ReportData, StoreData>): any => {
      context.commit("setReports", []);
    },

    getReports: (
      context: ActionContext<ReportData, StoreData>,
      params: any
    ): any => {
      return ReportService.getReports(params).pipe(
        tap((reports: Report[]) => {
          context.commit("addReports", reports);
        })
      );
    },

    downloadReport: (
      _context: ActionContext<ReportData, StoreData>,
      params: any
    ): any => {
      return ReportService.downloadReport(params.reportType, params.year).pipe(
        tap((res) => {
          const disposition = res.headers["content-disposition"].split(";");
          const item = disposition.find((item: string) =>
            item.startsWith("filename")
          );
          const fileName = item.replace("filename=", "");
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        }),
        map((r) => r),
        retry(1)
      );
    },
  },
  mutations: {
    addReports: (state: ReportData, reports: Report[]): void => {
      state.reports = state.reports.concat(reports);
    },
    setReports: (state: ReportData, reports: Report[]): void => {
      state.reports = reports;
    },
  },
} as Module<ReportData, StoreData>;
